module.exports = __webpack_public_path__ + "Female_student.e0d086e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/Female_student.png
// module id = Irbd
// module chunks = 0